var map = {
	"./goddess-mahalakshmi.jpg": 472,
	"./lord-ayyappa.jpg": 473,
	"./lord-hanuman.jpg": 474,
	"./lord-krishna.jpg": 475,
	"./lord-shiva.jpg": 476,
	"./lord-surya.jpg": 477,
	"./lord-vishnu.jpg": 478,
	"./nogod.png": 281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 471;